import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import styles from './TooltipFreePlan.module.scss';
import { Phrases } from '../../../utilities/constants/phrases';
import Tooltip, { Props as TooltipProps } from '../Tooltip';
import Button from '../../Button/Button';
import { ButtonAppearance, ButtonSize } from '../../ButtonBase/types';
import { useOpenSubscriptionPopup } from '../../../hooks/popup/useOpenSubscriptionPopup';

export enum Version {
  V1 = 'v1',
  V2 = 'v2',
}

const TITLE = {
  [Version.V1]: Phrases.TOOLTIP_FREE_PLAN_TITLE,
  [Version.V2]: Phrases.TOOLTIP_FREE_PLAN_TITLE_2,
};

const SUBTITLE = {
  [Version.V1]: Phrases.TOOLTIP_FREE_PLAN_SUBTITLE,
  [Version.V2]: Phrases.TOOLTIP_FREE_PLAN_SUBTITLE_2,
};

const CTA_BUTTON = {
  [Version.V1]: Phrases.TOOLTIP_FREE_PLAN_CTA_LABEL,
  [Version.V2]: Phrases.TOOLTIP_FREE_PLAN_CTA_LABEL_2,
};

interface Props extends Omit<TooltipProps, 'title'> {
  version?: Version;
}

const TooltipFreePlan: React.FC<Props> = ({
  version = Version.V1,
  ...props
}) => {
  const [open, setOpen] = useState<boolean>();
  const { handleOpenSubscriptionPopup } = useOpenSubscriptionPopup();

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => setOpen(undefined), 0);
  }, []);

  return (
    <Tooltip
      {...props}
      open={open}
      title={
        <div className={styles.tooltipFreePlan}>
          <p className='fw-bold c-white'>{TITLE[version]}</p>
          <p className={classNames(styles.subtitle, 'text-sm mt-xxxs mb-xs')}>
            {SUBTITLE[version]}
          </p>
          <div className='d-flex gap-xs flex-ai-c'>
            <Button
              appearance={ButtonAppearance.WHITE_BORDERED_GRADIENT}
              onClick={handleOpenSubscriptionPopup}>
              {CTA_BUTTON[version]}
            </Button>
            {version === Version.V1 && (
              <Button
                appearance={ButtonAppearance.TEXT}
                size={ButtonSize.SMALL}
                onClick={handleClose}
                className={styles.skipButton}>
                {Phrases.TOOLTIP_FREE_PLAN_SKIP_BUTTON_LABEL}
              </Button>
            )}
          </div>
        </div>
      }
    />
  );
};

export default TooltipFreePlan;
